export enum HazardType {
	None,
	Fire,
	Ice,
	Electric,
	ArmageddonPoison,
}
